<template>
  <div>
    <div class="header">
      <img class="home-logo" src="../../assets/yunnan/logo2.png"/>
    </div>

    <div class="lvf-content">
      <div class="lvf-content-left">
        <img class="home-bg" src="../../assets/yunnan/bg3.jpg"/>
      </div>
      <div class="lvf-content-right">
        <Alert v-show="isInvaild" type="error">无效用户！请联系管理员，将您添加至有效用户。</Alert>
        <Card v-show="showBinduser" :bordered="false" dis-hover>
            <bindUser :wxUid="wxUid" :appid="appid"/>
        </Card>
        <div v-show="!showBinduser" id="wxframe"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUrlQuery } from '@/utils/common.js'
import bindUser from '@/components/bindUser'
const CryptoJS = require('crypto-js')

export default {
  name: 'wxlogin',
  components: {
    bindUser
  },
  data () {
    return {
      isInvaild: false,
      appid: 'ww7bea9d70f1afc676',
      wxUid: '',
      showBinduser: false
    }
  },
  mounted () {
    // 页面初始化操作
    this.init()
  },
  methods: {
    init () {
      this.showBinduser = false
      this.initWxLogin()

      var code = getUrlQuery('code', window.location.href)
      if (code) {
        // 如果URL中包含CODE代码， 那么根据情况调整页面
        let scanBean = {
          appId: this.appid,
          code: code
        }

        this.$store.dispatch('LoginByScan', scanBean).then((data) => {
          const privateKey = data.privateKey
          const urlLoader = data.url
          // 加密登录信息,直接传输UserId
          const token = {
            Uid: data.scanUserId,
            AppId: this.appid,
            website: process.env.WEBSIT,
            type: data.type
          }

          const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(token), privateKey).toString()
          window.location.href = urlLoader + '?token=' + encodeURIComponent(ciphertext)
        }).catch((error) => {
          // CODE为未绑定的用户
          if (error.errcode === -7) {
            this.showBinduser = true
            this.wxUid = error.errmsg
          } else { // 企业微信未添加改用户至可信任区域
            this.isInvaild = true
          }
        })
      }
    },
    initWxLogin () {
      window.WwLogin({
        id: 'wxframe',
        appid: this.appid,
        agentid: '1000050',
        scope: 'snsapi_login',
        redirect_uri: 'http://jingjian.oohforce.com/ynLogin', // 转到当前地址以获取code值
        state: Math.random(),
        href: ''
      })
    }
  }
}
</script>

<style>
.header{
  margin-top: 100px;
  padding-right: 30px;
  text-align: center;
}
.home-logo{
  width: auto;
  height: 100px;
}
.home-bg{
  width: 950px;
}

.lvf-content{
  padding-top: 50px;
  margin: 0px auto;
  width: 100%;
  text-align: center;
}
.lvf-content-left{
  display: inline-block;
  padding-right: 30px;
  vertical-align: top;
}
.lvf-content-right{
  display: inline-block
}

.foother-href{
  font-size: 14px;
  margin-left: 10px;
  color: #2d8cf0 !important;
}
.lvf-footer{
  position: fixed;
  bottom: 25px;
  margin: 0px auto;
  width: 100%;
  text-align: center;
}
</style>
